<template>
  <section class="page">
    <slide-y-down-transition
      :delay="50"
      appear
    >
      <div class="page--header">
        <LowerThird class="page--lowerthird" />
        <div class="page--header__after decors-background-fond-etoile">
          <div class="decors-personnages-film-1" />
          <div class="decors-personnages-film-2" />
        </div>
      </div>
    </slide-y-down-transition>
    <div>
      <transition
        name="fade"
        appear
      >
        <PlayerVideo
          class="page--video"
          :youtube-id="youtubeId"
        />
      </transition>
      <SimpleButton
        to="/"
        class="page--backtohome"
      >
        {{ $config.common.backToHome }}
      </simplebutton>
    </div>
  </section>
</template>

<script>
import LowerThird from '@/components/common/lowerthird/LowerThird.vue';
import SimpleButton from '@/components/common/buttons/SimpleButton.vue';
import PlayerVideo from '@/components/utils/video/PlayerVideo.vue';

const DEFAULT_YOUTUBE_ID = 'EmC9Zo_up5s';

export default {
  name: 'Player',
  components: {
    LowerThird,
    SimpleButton,
    PlayerVideo,
  },

  data() {
    return {
    };
  },
  computed: {
    youtubeId() {
      return this.$store.state.attributes[this.$routeName] || DEFAULT_YOUTUBE_ID;
    },
  },
};
</script>
<style lang="stylus" scoped>
.page {

  &--header {
    margin: 0 auto;
    max-width: $container-width;
    width: calc(100% - var(--app-gutter));
    position: relative;

    &__after {
      position: absolute;
      top: 108px;
      border: 1px solid white;
      height: 530px;
      background-position: center;
      max-width: $container-width;
      width: 100%

      +mobile() {
        top: 92px;
        height: 290px;
      }

      & div:first-child {
        position: absolute;
        left: -180px;
        top: 35%;
      }

      & div:last-child {
        position: absolute;
        right: -140px;
        top: 35%
      }

      +mobile() {
        & div:first-child,
        & div:last-child {
          left: 50%;
          top: 52px;
          transform: translateX(-50%);
        }
      }
    }
  }

  &--lowerthird {
    margin: 0;
    padding: 0;
    z-index: 100;
    position: relative;
    width: 100%

    +mobile() {
      margin:0 auto 0;
    }
  }

  &--video {
    position: relative;
    z-index: 10;
    max-width: $content-width;
    width: calc(100% - 240px);
    margin: 60px auto 50px;
    +mobile() {
      margin: 160px auto 50px;
      width: calc(100% - 48px);
    }
  }

  &--backtohome {
    margin: 50px auto 20px;
    +mobile() {
      margin-top: 20px auto 20px;
    }
  }
}
</style>
